/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
 */
export interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  spitchEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  spitchUserId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  spitchChannelId: string;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate interface.
 */
export function instanceOfSingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate(
  value: object,
): value is SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('spitchEndpoint' in value) || value['spitchEndpoint'] === undefined) return false;
  if (!('spitchUserId' in value) || value['spitchUserId'] === undefined) return false;
  if (!('spitchChannelId' in value) || value['spitchChannelId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateFromJSON(
  json: any,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate {
  return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    spitchEndpoint: json['spitch_endpoint'],
    spitchUserId: json['spitch_user_id'],
    spitchChannelId: json['spitch_channel_id'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateToJSON(
  value?: SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    spitch_endpoint: value['spitchEndpoint'],
    spitch_user_id: value['spitchUserId'],
    spitch_channel_id: value['spitchChannelId'],
    credential_id: value['credentialId'],
  };
}
